import axios from 'axios';
import { API_URL, config } from '../../../config/config';

const getAllOrder = async (data, page) => {
	const response = await axios.post(`${API_URL}/Order/getallorder?page=${page}`, data, config);

	return response.data;
};

const getOrderMonthlyCount = async (data) => {
	const response = await axios.post(`${API_URL}/Order/getordersmonthlycounts`, data, config);

	return response.data;
};

const getOrderDetailsById = async (id) => {
	const response = await axios.post(`${API_URL}/Order/getorderdetailsbyid/${id}`, {}, config);

	return response.data;
};

const updateOrderStatus = async (data) => {
	const response = await axios.post(`${API_URL}/Order/updateorderstatus`, data, config);

	return response.data;
};

const getUsersAllOrder = async (data, page) => {
	const response = await axios.post(
		`${API_URL}/order/getusersallorders?page=${page}`,
		data,
		config
	);

	return response.data;
};

const getAllOrderCounts = async () => {
	const response = await axios.post(`${API_URL}/order/getallordercounts`, {}, config);
	return response.data;
};

const getUsersOrdersCounts = async () => {
	const response = await axios.post(`${API_URL}/order/getusersordercounts`, {}, config);
	return response.data;
};

const createOrder = async (orderDetails) => {
	const response = await axios.post(`${API_URL}/order/createorder`, orderDetails, config);
	return response.data;
};
const orderService = {
	getAllOrder,
	getOrderDetailsById,
	updateOrderStatus,
	getUsersAllOrder,
	getAllOrderCounts,
	getUsersOrdersCounts,
	createOrder,
	getOrderMonthlyCount,
};

export default orderService;
